<template>
    <div>
        <div>
            <b-button class="me-2" variant="light" @click="$eventHub.$emit('navigateBack')">
                <i class="fas fa-arrow-left"></i> Back
            </b-button>
            <b-button
            @click="addUser"
            style="float: right;"
            variant="light">
                Add Admin User
            </b-button>
        </div>
        <hr>
        <webix-ui :config="config" v-model="users_data"></webix-ui>
    </div>
</template>

<script>
import _ from 'lodash'
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        config:{
            id: 'applicantUsersTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'id', header:'', hidden: true},
                { id: 'name', header:'Name', fillspace: true},
                { id: 'last_login', header:'Last Login', fillspace: 0.5},
                { id: 'cell_no', header:'Contact', fillspace: 0.5},
                { id: 'email', header:'Email', fillspace: 0.5},
            ]
        }
    }),
    computed:{
        ...ccbAdminState,
        users_data(){
            let users = [];
            /*if( this.admin_users != null){
                users = this.admin_users;
            }*/
            if(this.client_data.users != null){
                users = _.cloneDeep(this.client_data.users);
            }
            return users;
        }
    },
    methods:{
        ...ccbAdminMethods,
        addUser(){
            let params = {
                id:-1,
                email: 'dylandutoit65@giil.com',
                name: 'DylanTest',
                password: 'password',
                cell_no: '0711454545',
                designation: 'test',
                id_number: '000080980',
                academic_qual: 'test',
                work_qual:' test',
                years_experience: '123',
            }

            this.saveAdminUser(params)
        }
    },
    mounted(){
        this.$nextTick(()=>{
            //eslint-disable-next-line
            let table = $$('applicantUsersTable');
            if(table != undefined){
                table.refresh();
            }
        })
    },
}
</script>

<style>

</style>